// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ***** ここに、あなたのプロジェクトのFirebase設定情報を貼り付けてください *****
const firebaseConfig = {
  apiKey: "AIzaSyBPJ_dULg7NVS__acIa10-eSLJ7l_v1CzM",
  authDomain: "learcareeonline.firebaseapp.com",
  projectId: "learcareeonline",
  storageBucket: "learcareeonline.firebasestorage.app",
  messagingSenderId: "508485210891",
  appId: "1:508485210891:web:c9ba8f9c2d781e32af080e"
};


// Firebaseサービスの初期化
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); // Firestoreの接続情報
export default app;